import Disclosure from '../disclosure';
import { FinderComponent, NO_RESULTS_CLASS, RESULTS_LIST_KEY, RESULTS_VIEW_CLASS } from './finder.component';

const TOTAL_NUMBER = '.finder__section-header .count';
const FUND_COLUMN = '#finder-funds';
const ARTICLES_COLUMN = '#finder-articles';
const STRATEGIES_COLUMN = '#finder-strategies';
const PERSONS_COLUMN = '#finder-persons';
const PAGES_COLUMN = '#finder-pages';
const TEASER_CLASS = 'finder__result';
const TEASER_TITLE_CLASS = 'teaser-title';
const TEASER_PRETITLE_CLASS = 'teaser-pretitle';
const TEASER_INFO_CLASS = 'teaser-info';

let totalResults = 0;

export default class QuickFinderComponent extends FinderComponent {
  loadResults(value) {
    jQuery.getJSON(
      `${Disclosure.getCurrentLangUrlPrefix()}/global-search/quick`,
      {
        query: value,
      },
      (results) => {
        this.renderResults(results);
        this.countResults(value);
        // this.highlightString(value);
      },
    );
  }

  renderResults(results) {
    this.clearResults();
    totalResults = 0;
    jQuery(TOTAL_NUMBER).text = '';

    if (results.funds && results.funds.results.length > 0) {
      this.getFundsBlock(results.funds);
      jQuery(FUND_COLUMN)
        .find(TOTAL_NUMBER)
        .text('(' + results.funds.total + ')');
      jQuery(FUND_COLUMN).show();
    } else if (results.strategies && results.strategies.results.length > 0) {
      this.getStrategiesBlock(results.strategies);
      jQuery(STRATEGIES_COLUMN)
        .find(TOTAL_NUMBER)
        .text('(' + results.strategies.total + ')');
      jQuery(STRATEGIES_COLUMN).show();
    }

    if (results.articles && results.articles.results.length > 0) {
      this.getArticlesBlock(results.articles);
      jQuery(ARTICLES_COLUMN)
        .find(TOTAL_NUMBER)
        .text('(' + results.articles.total + ')');
      jQuery(ARTICLES_COLUMN).show();
    }

    if (results.persons && results.persons.results.length > 0) {
      this.getPersonsBlock(results.persons);
      jQuery(PERSONS_COLUMN)
        .find(TOTAL_NUMBER)
        .text('(' + results.persons.total + ')');
      jQuery(PERSONS_COLUMN).show();
    }

    if (this.isColumnMissing(results) && results.pages && results.pages.results.length > 0) {
      this.getPagesBlock(results.pages);
      jQuery(PAGES_COLUMN)
        .find(TOTAL_NUMBER)
        .text('(' + results.pages.total + ')');
      jQuery(PAGES_COLUMN).show();
    }
  }

  isColumnMissing(results) {
    const resultsList = [];

    Object.entries(results).forEach((result) => {
      if (result[0] !== 'pages') {
        resultsList.push(result[1].total);
      }
    });

    return resultsList.includes(0);
  }

  getColumnContent(title, info, url, selector) {
    const teaser = `<a class="${TEASER_CLASS}" href="${url}">
                      <div class="${TEASER_TITLE_CLASS}">${title}</div>
                      <div class="${TEASER_INFO_CLASS}">${info}</div>
                    </a>`;

    jQuery(selector).find(RESULTS_LIST_KEY).append(teaser);
  }

  getFundsBlock(funds) {
    const total = typeof funds.total === 'number' ? funds.total : 0;
    totalResults += total;

    Object.entries(funds.results).forEach((result) => {
      if (result[1].url != null) {
        const url = result[1].url;
        let title = result[1].legalName ? `<div class="${TEASER_TITLE_CLASS}">${result[1].legalName}</div>` : '';

        if (result[1].assetClass) {
          title = `<div class="${TEASER_PRETITLE_CLASS}">${result[1].assetClass}</div> ${title}`;
        }

        const info = `<span>${result[1].shareClassType}</span>
                        <span>${result[1].currency}</span> /
                        <span>ISIN: ${result[1].isin}</span>`;

        const teaser = `<a class="${TEASER_CLASS}" href="${url}">
                        ${title}
                        <div class="${TEASER_INFO_CLASS}">${info}</div>
                      </a>`;

        jQuery(FUND_COLUMN).find(RESULTS_LIST_KEY).append(teaser);
      }
    });
  }

  getStrategiesBlock(strategies) {
    const total = typeof strategies.total === 'number' ? strategies.total : 0;
    totalResults += total;

    Object.entries(strategies.results).forEach((result) => {
      if (result[1].url != null) {
        const url = result[1].url;
        const title = result[1].title ? result[1].title : '';
        const info = result[1].summary ? result[1].summary : '';

        this.getColumnContent(title, info, url, STRATEGIES_COLUMN);
      }
    });
  }

  getArticlesBlock(articles) {
    const total = typeof articles.total === 'number' ? articles.total : 0;
    totalResults += total;

    Object.entries(articles.results).forEach((result) => {
      if (result[1].url != null) {
        const url = result[1].url;
        const title = result[1].title ? result[1].title : '';
        const authors = result[1].authors ? this.getAuthorsList(result[1].authors) : '';
        const info = result[1].publishDate
          ? `<div class="teaser-info--grey">${result[1].publishDate}</div>${authors}`
          : '';

        this.getColumnContent(title, info, url, ARTICLES_COLUMN);
      }
    });
  }

  getPersonsBlock(persons) {
    const total = typeof persons.total === 'number' ? persons.total : 0;
    totalResults += total;

    Object.entries(persons.results).forEach((result) => {
      if (result[1].url != null) {
        const url = result[1].url;
        const title = result[1].title ? result[1].title : '';
        const info = result[1].role ? result[1].role : '';

        this.getColumnContent(title, info, url, PERSONS_COLUMN);
      }
    });
  }

  getPagesBlock(pages) {
    const total = typeof pages.total === 'number' ? pages.total : 0;
    totalResults += total;

    Object.entries(pages.results).forEach((result) => {
      if (result[1].url != null) {
        const url = result[1].url;
        const title = result[1].title ? result[1].title : '';
        const info = result[1].summary ? result[1].summary : '';

        this.getColumnContent(title, info, url, PAGES_COLUMN);
      }
    });
  }

  getAuthorsList(authors) {
    if (!authors || typeof authors === 'undefined') {
      return '';
    }

    return authors.join(', ');
  }

  countResults(inputValue) {
    this.clearCount();
    const query = encodeURIComponent(inputValue.replace(/["]+/g, ''));
    let message = `<span>${Drupal.t('No results found')}</span>`;
    const link = `${Disclosure.getCurrentLangUrlPrefix()}/search?query=${query}`;

    if (totalResults > 0) {
      message = `<a href="${link}">${Drupal.t('See all results')} <span>(${totalResults})</span></a>`;
    }

    this.dropdownElement.append(
      `<div class="${RESULTS_VIEW_CLASS} ${totalResults <= 0 ? NO_RESULTS_CLASS : ''}">${message}</div>`,
    );
  }

  showLoader() {
    this.dropdownElement.append(
      `<div class="${RESULTS_VIEW_CLASS}"><span class="loader__wrapper">
        ${Drupal.t('Searching...')} <span class="loader"></span></span>
        </div>`,
    );
  }
}
